<template>
  <div class="page" id="page-contents">
    <div class="section detail event" id="section-contents-landing">
      <div class="container">
        <div class="header">
          <img alt="로고" src="/static/carousel-icon.png" />
          <p>make sure your sure</p>
        </div>
        <div class="body">
          <h3>인슈넷 FC의 다양한 콘텐츠 정보를 확인해보세요.</h3>
        </div>
      </div>
    </div>

    <div class="section" id="section-contents-items">
      <div class="container">
        <div class="section-title">
          <p>EVENTS</p>
        </div>
        
        <div class="section-header">
          <div class="container">
            <div class="description-header">
              <h1 class="hash">{{ content.document_category }}</h1>
              <h1>{{ content.title }}</h1>
            </div>

            <div class="date">{{ content.createdAt }}</div>
            <el-row class="description-bottom">
              <el-col :span="6" class="left">
                <div>견적 신청 수 <span> {{ (content.estimate_requests || 0).toLocaleString() }}</span></div>
                <div>조회 수 <span> {{ (content.views || 0).toLocaleString()}} </span></div>
              </el-col>
              <el-col :span="12" v-if="content.document_extra">
                <el-button
                  v-for="(link, index) in content.document_extra.links"
                  :key="index"
                  size="mini"
                  class="link-btn link"
                  @click="(event) => moveToURL(event, link.url)"
                  circle
                >
                  <img :src="`/static/contents/${link.linkType}.png`" :alt="link.linkType" class="link"/>
                </el-button>
              </el-col>
              <el-col :span="6" :offset="6" class="right">
                <!-- <button type="text">
                  <img src="/static/contents/icon-share.png" alt="링크 공유" />
                </button>
                <button type="text">
                  <img src="/static/contents/icon-heart.png" alt="좋아요" />
                </button> -->
                <el-button
                  type="primary"
                  class="list-btn"
                  @click="moveToContents"
                  round
                >전체목록</el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-divider />
        <div class="section-body">
          <div v-html="content.content" />
          <el-row class="mb-2">
            <el-col :md="8" :sm="12" :xs="24" class="help-col">
              <el-card shadow="never" class="help-box">
                <div v-if="step === 1">                  
                  <div class="body" style="margin-top: 2rem; padding: 20px;">
                    <p><span class="text-blue">{{ (content.like || 0).toLocaleString() }}명</span>이 이 글이 도움이 되었다고 하였습니다.</p>
                    <h1>이 글이 <span class="text-blue">도움</span>이 되었습니까?</h1>
                    <el-row class="button-group">
                      <el-button type="primary" @click="clickHelpSubmit">네</el-button>
                      <el-button @click="clickHelpNoSubmit">아니요</el-button>
                    </el-row>
                  </div>
                </div>

                <div v-if="step === 2">
                  <div class="header">
                    <el-button type="text" @click="step = 1">
                      <i class="el-icon-arrow-left" />
                      뒤로가기
                    </el-button>
                  </div>
                  <div class="body">
                    <h1>어떻게 하면 <span class="text-blue">개선</span>할 수 있을까요?</h1>
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 4}"
                      placeholder="여러분의 의견을 자유롭게 남겨주세요~!"
                      v-model="message"
                    />
                    <el-button class="btn-submit" @click="sendToMessage">의견 보내기</el-button>
                  </div>
                </div>

                <div v-if="step === 3">
                  <div class="body">
                    <h1>소중한 의견 <span class="text-blue">감사합니다!</span></h1>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="section" id="section-contents-comment">
      <div class="container">
        <h1><span class="text-blue">여러분의 의견</span>을 자유롭게 남겨주세요!</h1>
        <el-row :gutter="20">
          <el-col :sm="18" :md="20">
            <el-input
              type="textarea"
              placeholder="댓글을 자유롭게 남겨주세요~!"
              v-model="comment"
            />
          </el-col>
          <el-col :sm="6" :md="4">
            <el-button class="submitComment" @click="submitComment">댓글 입력</el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="section" id="section-comments">
      <div class="container">        
        <el-collapse
          v-for="(item, index) in comments"
          :key="index"
        >
          <el-collapse-item :name="item.title" :disabled="!item.post_content_reply">
            <template slot="title">
              <div class="collapse-content">
                <p>
                  <span>{{ item.num }}</span>
                  {{ item.post_content }}
                </p>
              </div>
              <el-row class="collapse-buttons">
                <!-- <el-button
                  class="btn-blue"
                  round
                  size="mini"
                  v-if="customer_id !== item.customer_id"
                >
                  답글달기
                </el-button> -->
                <el-button
                  type="info"
                  size="mini"
                  icon="el-icon-edit-outline"
                  v-if="customer_id === item.customer_id"
                  @click="() => { edit = true; comment = item.post_content; commentId = item._id }"
                  round
                >
                  수정
                </el-button>
                <el-button
                  icon="el-icon-delete"
                  size="mini"
                  v-if="customer_id === item.customer_id"
                  @click="deleteComment(item)"
                  round
                >
                  삭제
                </el-button>
              </el-row>
            </template>
            <div v-if="item.post_content_reply" class="collapse-reply">
              <img src="/static/contents/reply-logo.png" alt="인슈넷FC" />
              <p>{{ item.post_content_reply }}</p>
            </div>
          </el-collapse-item>
        </el-collapse>

        <el-row :gutter="20" class="my-2">
          <el-col
            :span="12"
            :offset="6"
            class="pagination"
          >
            <el-button
              type="text"
              icon="el-icon-d-arrow-left"
              class="first-btn"
              @click="moveToFirstPage"
            ></el-button>
            <el-pagination
              :page-size="5"
              :pager-count="11"
              layout="prev, pager, next"
              :total="total"
              :current-page="page"
              @current-change="getPost"
            ></el-pagination>
            <el-button
              type="text"
              icon="el-icon-d-arrow-right"
              class="last-btn"
              @click="moveToLastPage"
            ></el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <div id="floating-button" ref="floating-button">
      <el-button type="primay" @click="moveToCompareEstimate" round>
        <img src="/static/contents/compare-icon.png" alt="비교견적 신청하기" />
        <span>비교견적 신청하기</span>
      </el-button>
    </div>

    <el-dialog title="댓글 수정" :visible.sync="edit" id="comment-dialog">
      <div>
        <el-input type="text" v-model="comment" />
      </div>
      <el-row slot="footer" class="dialog-footer">
        <el-button @click="edit = false">취소</el-button>
        <el-button type="primary" @click="modifyComment">수정</el-button>
      </el-row>
    </el-dialog>

    <Footer />
  </div>
</template>

<script>
import { Row, Col, Divider, Card, Button, Input, Collapse, Dialog } from 'element-ui';
import moment from 'moment';
import Footer from "../../view/layout/Footer.vue";

/*
3. 비교견적 신청 시 어디로 이동하면 되는지 확인 필요 
  => data_document 테이블 내 document_category의 보험종목의 보험료 비교신청 페이지로 이동 기타의 경우에는 홈으로 이동
*/
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Divider.name]: Divider,
    [Card.name]: Card,
    [Button.name]: Button,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [Dialog.name]: Dialog,
    Footer,
  },
  data() {
    return {
      id: this.$route.query.id,
      document_category: '',
      content: {},
      step: 1,
      message: '',
      postCategory: '',
      comment: '',
      comments: [],
      customer_id: '',
      page: 1,
      size: 5,
      total: 0,
      edit: false,
      commentId: '',
    }
  },
  mounted() {
    const { profile } = this.$store.state.customer;

    if (!this.id) {
      history.back();
    }

    if (profile) {
      this.customer_id = profile._id;
    }

    document.querySelector('body').addEventListener('scroll', this.handleScroll);

    this.getContent();
    this.getPost();
  },
  beforeDestroy() {
    document.querySelector('body').removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getContent() {
      this.$store
        .dispatch('etc/getContent', { id: this.id })
        .then(res => {
          const { data } = res.data;
          const { document_category, views } = data;
          this.document_category = document_category;
          console.log(data.document_extra)
          this.content = {
            ...data,
            document_category: document_category.indexOf('보험') === -1 ? `#${document_category}보험` : `#${document_category}`,
            document_extra: JSON.parse(data.document_extra),
            createdAt: moment(data.createdAt).format('YYYY-MM-DD')
          }

          this.$store.dispatch('etc/updateContent', {
            id: this.id,
            data: {
              views: (views * 1) + 1
            }
          })
        });
    },
    getPost(page) {
      this.$store
        .dispatch('post/getItemByDocumentId', {
          document_id: this.id,
          page: page || 1,
          size: this.size
        })
        .then(res => {
          const { data, error } = res.data;

          if (error || data.total === 0) {
            this.step = 1;
            return;
          }
          
          this.total = data.total;
          this.comments = data.items.map(d => ({
            ...d,
            num: (d.num < 10 ? '0' + d.num : d.num),
            post_content: d.post_content || ''
          }));
          const isWrote = this.comments.filter(comment => comment.customer_id === this.customer_id);
          
          if (isWrote.length) {
            this.step = 3;
          }
        })
    },
    clickHelpSubmit() {
      this.postCategory = 'good';
      this.submitPost({
        subject: { value: this.content.title },
        post: { value: '' },
      }, this.changeStep)
      this.updateHelpCount(this.postCategory);
    },
    clickHelpNoSubmit() {
      this.updateHelpCount('bad');
      this.step = 2;
    },
    sendToMessage() { 
      this.postCategory = 'bad';
      if (this.message === '') {
        this.$message({ message: '의견을 입력해주세요', type: 'error' });
        return;
      }

      this.submitPost({
        subject: { value: this.content.title },
        post: { value: this.message },
      }, this.changeStep);
    },
    changeStep() {
      this.step = 3;
    },
    submitPost(params, cb) {
      const { profile } = this.$store.state.customer;
      let data = {
        document_id: this.id,
        category: this.postCategory,
        board: 'board_document',
        ...params
      }

      if (profile._id) {
        data.user = profile;
      }

      this.$store.dispatch("post/updateItems", data).then(() => {
        cb();
      });
    },
    submitComment() {
      this.submitPost({
        subject: { value: this.content.title },
        post: { value: this.comment }
      }, () => {
        this.comment = '';
        this.getPost(1);
      });
    },
    moveToFirstPage() {
      this.page = 1;
    },
    moveToLastPage() {
      this.page = this.total / 5;
    },
    modifyComment() {
      if (confirm('댓글을 수정하시겠습니까?')) {
        this.$store
          .dispatch("post/updateItem", { id: this.commentId, post_content: this.comment })
          .then(() => {
            this.$message({
              type: 'success',
              message: '댓글을 수정했습니다.'
            });

            this.comment = '';
            this.edit = false;
            this.getPost(1);
          });
      }
    },
    deleteComment({ _id }) {
      if (confirm('댓글을 삭제하시겠습니까?')) {
        this.$store
          .dispatch("post/deleteItem", { id: _id })
          .then(() => {
            this.$message({
              type: 'success',
              message: '댓글을 삭제했습니다.'
            });

            this.getPost(1);
          });
      }
    },
    moveToCompareEstimate() {
      const { _id, estimate_requests } = this.content;

      const component = {
        '자동차': 'CarInsurance',
        '운전자': 'DriverInsurance',
        '실손': 'EstimateLosslessMedicalInsurance',
        '암': 'CancerInsurance',
        '어린이': 'ChildInsurance',
        '태아': 'FetalInsurance',
        '정기': 'TermInsurance',
        '종신': 'WholeLifeInsurance',
        '화재': 'FireInsurance',
        '연금': 'PensionInsurance',
        '치아': 'DentalInsurance',
        '치매': 'DementiaInsurance',
        '펫': 'PetInsurance'
      }[this.document_category] || 'Home';

      this.$store.dispatch('etc/updateContent', {
        id: _id,
        data: {
          estimate_requests: (estimate_requests * 1) + 1
        }
      });

      this.$router.push({ name: component });
    },
    handleScroll(e) {
      const $floatingButton = this.$refs['floating-button'];
      const { scrollTop, scrollHeight, offsetHeight } = e.target;
      const footerHeight = document.querySelector('#site-footer').offsetHeight;
      const maxY = offsetHeight + footerHeight;
      const positionY = scrollHeight - scrollTop;

      if (scrollTop === 0) {
        return $floatingButton.style.display = 'none';
      }

      $floatingButton.style.display = 'block';
    },
    updateHelpCount(type) {
      const { _id, like, bad } = this.content;
      let data = {};

      if (type === 'good') {
        data.like = (like * 1) + 1;
      } else {
        data.bad = (bad * 1) + 1;
      }

      this.$store.dispatch('etc/updateContent', { id: _id, data });
    },
    moveToContents() {
      this.$router.push({ name: 'Contents' });
    },
    moveToURL(event, url) {
      event.preventDefault();
      window.open(url);
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-body {
    div > ::v-deep figure.table {
      height: auto !important;
      margin-bottom: 2*$unit !important;

      @include media-mobile {
        table {
          width: unset !important;

          * {
            font-size: 1.5*$unit;
          }
        }
      }
    }
  }
  .link-btn {
    position: relative;
    display: inline-flex;
    margin: 4px 8px;
    margin-top: 4px !important;
    width: 28px !important;
    height: 28px;
    border-radius: 100%;
    overflow: hidden;
    background: #fff;
    border: 1px solid #bfbfbf;
    padding: 2px;
    box-sizing: content-box;
    cursor: pointer;

    img {
      width: 28px;
      height: 28px;
      border-radius: 100%;
      display: inline-flex;
      font-size: 28px;
    }
  }
</style>